<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'footers.dialog.selectOption' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="onNoClick()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <mat-radio-group [(ngModel)]="selectedOption" class="radio-group">
      <mat-radio-button *ngFor="let option of options" [value]="option.value" class="radio-button">
        {{ option.label | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="onNoClick()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="confirmSelection()">
      {{ 'set' | translate }}
    </button>
  </footer>
</div>
